import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getOperators as getOperatorsApi,
    createOperator as createOperatorApi,
    updateOperator as updateOperatorApi,
    getOperatorUsers as getOperatorUsersApi,
    updateUserPassword as updateUserPasswordApi
} from "../../helpers/apis";
import { toast } from 'react-toastify';

export const getOperators = createAsyncThunk("operators/getOperators", async (params, thunkAPI) => {
    try {
        const response = await getOperatorsApi(params);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const createOperator = createAsyncThunk("operators/createOperator", async (data, thunkAPI) => {
    try {
        const response = await createOperatorApi(data);
        if (response.success || response.status === 1) {
            toast.success("Operator created successfully");
        } else {
            toast.error(response.message || "Failed to create operator");
        }
        return response;
    } catch (error) {
        toast.error(error.message || "Failed to create operator");
        return thunkAPI.rejectWithValue(error);
    }
});

export const updateOperator = createAsyncThunk("operators/updateOperator", async ({ id, data }, thunkAPI) => {
    try {
        const response = await updateOperatorApi(id, data);
        if (response.success || response.status === 1) {
            toast.success("Operator updated successfully");
        } else {
            toast.error(response.message || "Failed to update operator");
        }
        return response;
    } catch (error) {
        toast.error(error.message || "Failed to update operator");
        return thunkAPI.rejectWithValue(error);
    }
});

export const getOperatorUsers = createAsyncThunk("operators/getOperatorUsers", async (operatorId, thunkAPI) => {
    try {
        const response = await getOperatorUsersApi(operatorId);
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

export const updateUserPassword = createAsyncThunk("operators/updateUserPassword", async ({ userId, data }, thunkAPI) => {
    try {
        const response = await updateUserPasswordApi(userId, data);
        if (response.success || response.status === 1) {
            toast.success("Password updated successfully");
        } else {
            toast.error(response.message || "Failed to update password");
        }
        return response;
    } catch (error) {
        toast.error(error.message || "Failed to update password");
        return thunkAPI.rejectWithValue(error);
    }
});
